import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for Home Header component customisation
 * Returns header container background styling
 */
export const useHomeHeaderCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.HOME,
    sectionKey: PUI.HOME_SECTION_KEYS.HEADER_BACKGROUND,
    blockKey: PUI.HOME_BLOCK_KEYS.HEADER,
  });

  const backgroundType = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_TYPE);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const backgroundImage = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_IMAGE);

  return {
    isVisible,
    backgroundType,
    backgroundColor,
    backgroundImage,
  };
};
